
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new_password",
      function () {
        return require("private-next-pages/new_password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new_password"])
      });
    }
  